import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SearchApartmentChecklist, SearchApartmentChecklistOption } from '../../data/interface';
import { getQuestions } from '../../data/data';
import { Router } from '@angular/router';
import { SearchAvailabilityQuery } from '../../core/models/booking-model';
import { BtrBookingService } from '../../core/services/btr-booking.service';
import { CountryGroupItem, ReadApplicationConfigurationsRS } from '../../core/api/api.models';

@Component({
  selector: 'app-search-question',
  standalone: false,
  templateUrl: './search-question.component.html',
  styleUrls: ['./search-question.component.sass']
})
export class SearchQuestionComponent implements OnInit, OnDestroy {
  questions: SearchApartmentChecklist[] = [];
  currentQuestion: number = 0;
  
  constructor(
    private router: Router,
    private btrBooking: BtrBookingService,
  ){
    
  }

  @ViewChild('carousel') carousel: any;
  @Input() hotel: CountryGroupItem | undefined

  ngOnInit(): void {
    // this.readApplicationConfigurations();
  }

  ngAfterViewInit(){
    
  }

  ngOnDestroy(): void {
    
  }

  readApplicationConfigurations(){
    this.btrBooking.readApplicationConfigurations().subscribe({
      next: (res) => {
        this.readApplicationConfigurationsSuccess(res);
      }
    })
  }

  readApplicationConfigurationsSuccess(res: ReadApplicationConfigurationsRS){
    if(!res.success || !res.applicantTypes){
      return;
    }

    const questions = getQuestions();
    const applicantTypeQuestion = questions.find(e => e.name === 'applicant_type');
    if(applicantTypeQuestion){
      applicantTypeQuestion.options = res.applicantTypes.map(e => ({
        title: e.name,
        value: e.code
      }));
    }

    this.questions = questions;
  }

  search(){
    const params: SearchAvailabilityQuery = {
      property: this.hotel?.hotelRefID || '',
      fromDate: new Date(),
      bathRooms: 1,
      bedRooms: 1,
      isHasPet: false,
      isNeedExtraStorage: false,
      isNeedParking: false,
      applicantType: ''
    };

    const applicantTypeQuestion = this.questions.find(e => e.name === 'applicant_type');
    if(applicantTypeQuestion){
      const selectedOption = applicantTypeQuestion.options?.find(e => e.isSelected);
      if(selectedOption){
        params.applicantType = selectedOption.value as string;
      }
    }

    const bedQuestion = this.questions.find(e => e.name === 'bedrooms');
    if(bedQuestion){
      const selectedOption = bedQuestion.options?.find(e => e.isSelected);
      if(selectedOption){
        params.bedRooms = parseInt(selectedOption.value as string);
      }
    }

    const bathQuestion = this.questions.find(e => e.name === 'bathrooms');
    if(bathQuestion){
      const selectedOption = bathQuestion.options?.find(e => e.isSelected);
      if(selectedOption){
        params.bathRooms = parseInt(selectedOption.value as string);
      }
    }

    const parkingQuestion = this.questions.find(e => e.name === 'need_parking');
    if(parkingQuestion){
      
    }

    const whoMoveInQuestion = this.questions.find(e => e.name === 'who_moving_in');
    if(whoMoveInQuestion){
      const selectedOption = whoMoveInQuestion.options?.find(e => e.isSelected);
      if(selectedOption){
        params.whoMovingIn = selectedOption.value as string;
      }
    }



    const queryString = this.btrBooking.createSearchAvailabilityQueryString(params);
    this.router.navigateByUrl(`/apartments/results?${queryString}`);
  }

  selectOption(options: SearchApartmentChecklistOption[], option: SearchApartmentChecklistOption){
    options.forEach(e => {
      e.isSelected = false;
    })
    option.isSelected = !option.isSelected;
  }

  onPageChanged(event: any){
    this.currentQuestion = event.page;
  }

  isLastPage(){
    return this.currentQuestion === this.questions.length - 1;
  }

  next(){
    if(!this.carousel) return;
    if(this.currentQuestion > this.questions.length - 2){
      this.search();
      return;
    }
    this.carousel.navForward(null, this.currentQuestion + 1);
  }

  prev(){
    if(!this.carousel || !this.currentQuestion) return;

    this.carousel.navBackward(null, this.currentQuestion - 1);
  }
}
